/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import { RefundHistoryTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import Swal from 'sweetalert2';
// import BookingHistoryFilterHeader from '../../../../Componant/Application/Ecommerce/ProductList/BookingHistoryFilterHeader';

const RefundHistoryContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [bookingHistoryTableDatas, setBookingHistoryTableDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchRefunds = async (page: number, size: number) => {
    setLoading(true);
    try {
      const response = await api.get(`/api/Refund/GetAllRefundPagination?pageNumber=${page}&pageSize=${size}`);
      if (response.status === 200) {
        setBookingHistoryTableDatas(response.data.items.map((item: any): RefundHistoryTableDataColumnType => ({
          refundableId: item.refundableId,
          ticketRFIdRef: item.ticketRFIdRef || "",
          rfidCardNumber: item.rfidCardNumber || "",
          refundableAmount: item.refundableAmount || 0,
          customerMobileNumber: item.customerMobileNumber || "",
          refundDate: new Date(item.refundDate).toISOString().split('T')[0] || "",
          refundType: item.refundType || "",
        })));
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      // console.error("Failed to fetch booking history:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRefunds(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: string) => {
    // Your delete logic here (API call, state update, etc.)
    // console.log("Deleting ID:", id);
    try {
      await api.put(`/api/Auth/DeActiveStaffRegistration?userId=${id}`);
      Swal.fire('Deactivate!', ' Staff has been deactivated successfully.', 'success');

      // Optional: refresh the list
      // setBookingHistoryTableDatas((prev) => prev.filter((item: { userId: any; }) => item.userId !== id));
      await fetchRefunds(currentPage, pageSize); // Refresh the data after deletion
    } catch (error) {
      Swal.fire('Error!', 'Failed to deactivate the staff.', 'error');
      console.error("Deactivate error:", error);
    }
  };

  const refundHistoryTableDataColumn: TableColumn<RefundHistoryTableDataColumnType>[] = [
    {
      name: "Refundable ID",
      selector: (row) => row.refundableId,
      sortable: true,
    },
    {
      name: "Ticket ID",
      selector: (row) => row.ticketRFIdRef,
      sortable: true,
    },
    {
      name: "RFID Card No.",
      selector: (row) => row.rfidCardNumber,
      sortable: true,
    },
    {
      name: "Refundable Amount",
      selector: (row) => row.refundableAmount,
      sortable: true,
    },
    {
      name: "Customer Mobile No.",
      selector: (row) => row.customerMobileNumber,
      sortable: true,
    },
    {
      name: "Refund Date",
      selector: (row) => row.refundDate,
      sortable: true,
    },
    {
      name: "Refund Type",
      selector: (row) => row.refundType,
      sortable: true,
    },
    // Add more columns or actions as needed
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const filteredItems = bookingHistoryTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                {/* <BookingHistoryFilterHeader /> */}
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable data={filteredItems} columns={refundHistoryTableDataColumn} striped highlightOnHover pagination paginationServer paginationTotalRows={totalRows} onChangePage={handlePageChange} onChangeRowsPerPage={handlePerRowsChange} paginationDefaultPage={currentPage} paginationPerPage={pageSize} progressPending={loading} selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} noDataComponent="No records found matching your search, try remove initial zero from RFID Card No. and search again." />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default RefundHistoryContainer